import Form from '@utilities/form';
import ScrollTo from '@utilities/scroll-to';
import { body } from '@utilities/dom-elements';
import registerConstraints from './register-constraints';

const JS_HOOK_REGISTER_ALERT = '[js-hook-register-alert]';
const JS_HOOK_REGISTER_BODY = '[js-hook-register-form-body]';
const JS_HOOK_CONSENT_ONE = '[js-hook-consent-one]';
const JS_HOOK_CONSENT_TWO = '[js-hook-consent-two]';

/**
 * Used to hand register request from user
 *
 * @class RegisterForm
 * @extends {Form}
 */
class RegisterForm extends Form {
  constructor(element) {
    super(element);
    this.body = element.closest(JS_HOOK_REGISTER_BODY);
    this.locale = this.form.dataset.locale;
    this.messageSelector = JS_HOOK_REGISTER_ALERT;
    this.consent1 = document.querySelector(JS_HOOK_CONSENT_ONE);
    this.consent2 = document.querySelector(JS_HOOK_CONSENT_TWO);

    // Init constraints
    this.initConstraints();

    // Events: Submit & Change Events
    this.bindChangeEvents();
    this.bindSubmitEvents();
  }

  /**
   * Init constraints for form validation for validate.js
   */
  initConstraints() {
    this.constraints = registerConstraints(this.locale, this.customValidationMessages);
  }

  updateHTML(message) {
    ScrollTo.scrollTo(body);
    this.body.innerHTML = `<p class="u-text u-text--centered">${message}</p>`;
    this.body.setAttribute('tabindex', -1);
    this.body.focus();
  }

  afterSubmitFormSuccess({ receivedMsgBody, success, email }) {
    if (receivedMsgBody && success) {
      this.updateHTML(receivedMsgBody);
      this.form.reset();
    }

    if (email && window._etmc) window._etmc.push(['setUserInfo', { email }]);
  }

  bindChangeEvents() {
    if (this.consent1 && this.consent2) {
      this.consent1.addEventListener('change', () => {
        if (this.consent1.checked) {
          this.consent2.removeAttribute('disabled');
        } else {
          this.consent2.setAttribute('disabled', 'disabled');
          this.consent2.removeAttribute('checked');
        }
      });
    }
  }
}

export default RegisterForm;
